import { useTranslation } from "react-i18next";
import ContactHero from "../components/contact/ContactHero";
import ContactForm from "../components/contact/ContactForm";

export default function Contact() {
  const { t } = useTranslation();
  return (
    <main data-testid="contact-page">
      <ContactHero />
      <section
        data-testid="contact-form-section"
        className="pb-24 md:pb-32 bg-white"
      >
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="text-center mb-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
              {t("contact.form.title")}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-600 max-w-xl mx-auto">
              {t("contact.form.subtitle")}
            </p>
          </div>
          <ContactForm />
        </div>
      </section>
    </main>
  );
}
